<div class="row w-100 pt-3 text-center row-title">
    @if (!active) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Activation messagerie visuelle pour iPhone</div>
    }
    @if (active) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Désactivation messagerie visuelle pour iPhone</div>
    }
</div>
<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100">
        @if (!active) {
            <div class="text-center pb-4">Attention, cette option n'est compatible qu'avec les produits de la marque Apple!</div>
        }
        @if (active) {
            <div class="text-center pb-4">Je souhaite désactiver l'option messagerie vocale visuelle pour iPhone sur ma ligne <strong>{{ line.phoneNumber }}</strong></div>
        }
        @if (!active) {
            <div class="float-left">Pour obtenir votre IMEI, composez le *#06# sur le clavier de votre téléphone puis appuyez sur la touche d'appel.</div>
        }
        <br/><br/>
        <form [formGroup]="visualForm" (submit)="confirmation()">
            @if (!active) {
                <div class="form-group pb-1">
                    <span class="bold-label-text float-left">IMEI*</span>
                    <input type="text" class="form-control" placeholder="IMEI" formControlName="imei" required>
                    @if (visualFormSubmitted && visualForm.controls.imei.errors) {
                        <p class="error-message">Ce champ est obligatoire</p>
                    }
                </div>
            }
            @if (!active) {
                <div class="form-group pb-1">
                    <span class="bold-label-text float-left">Marque*</span>
                    <input type="text" class="form-control" placeholder="Marque" formControlName="brand" required>
                    @if (visualFormSubmitted && visualForm.controls.model.errors) {
                        <p class="error-message">Ce champ est obligatoire</p>
                    }
                </div>
            }
            @if (!active) {
                <div class="form-group pb-1">
                    <span class="bold-label-text float-left">Modèle*</span>
                    <input type="text" class="form-control" placeholder="Modèle" formControlName="model" required>
                    @if (visualFormSubmitted && visualForm.controls.model.errors) {
                        <p class="error-message">Ce champ est obligatoire</p>
                    }
                </div>
            }
            @if (!active) {
                <div class="form-group pb-1">
                    <span class="float-left">L'option de messagerie visuelle est disponible gratuitement.</span>
                </div>
            }
            <br/>
            <div class="cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
            </div>
        </form>
    </div>
</div>
